import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import AppActions from './app/app_actions'

import { composeWithDevTools } from 'redux-devtools-extension';

const composeEnhancers = composeWithDevTools({
// Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

/**/
export const store = createStore(
rootReducer,   
composeEnhancers(applyMiddleware(thunk))
);

/*
// Con lo store
export const store = createStore(
    rootReducer,
    (window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()),
    applyMiddleware(thunk)
);

/*
// Aggiungendo tramite un package esterno la funzione di helper come sotto:
export const store = createStore(
    rootReducer,  
    persistedState,   
    composeEnhancers(applyMiddleware(thunk))
    );
    */